import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ReceiptType, IsEnable } from "../../utils/enums";
import { SaleBill } from "../../components/SaleBill";
import { Form, Input, Button, Alert, Spin } from "antd";
import * as Components from "../../components";
import { useReactToPrint } from "react-to-print";
import dayjs from "dayjs";
import { owntoast } from "../../utils";
import Modal from "./Modal";

/* Шинэ эсвэл засах цонх бүгд ашиглах */
function AddOrEdit(props) {
  const { page } = props;
  const printRef = useRef();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const [files, setFiles] = useState({});
  const [initData, setInitData] = useState([]);
  const [changed, setChanged] = useState({});
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [editData, setEditData] = useState({});
  const [printData, setPrintData] = useState({});
  /* const editData = useEditDataHook(props, page.model); */
  useEffect(() => {
    let permResult = true;
    if (
      params["*"].includes("edit") &&
      searchParams.get("index") &&
      permResult
    ) {
      let edit = JSON.parse(localStorage.getItem("editRow"));
      if (edit) {
        let files = {};
        setPrintData({
          ...edit,
          type: ReceiptType.Карт,
          vatname: props._auth.vatname,
        });
        Object.keys(edit).map((keyname) => {
          if (keyname.includes("img") || keyname.includes("icon")) {
            files[`prev${keyname}`] = edit[keyname];
            delete edit[keyname];
          }
          if (keyname.includes("ymd")) edit[keyname] = dayjs(edit[keyname]);
          if (keyname === "hastax")
            edit[keyname] = edit[keyname]
              ? IsEnable.Идэвхтэй
              : IsEnable.Идэвхгүй;
        });
        edit.files = files;
        form.setFieldsValue({ ...edit });
        if (edit.files) setFiles(edit.files);
        setEditData(edit);
      }
    } else if (permResult && !page.islist && page.initialValues) {
      let files = {};
      Object.keys(page.initialValues).map((keyname) => {
        if (keyname.includes("banner") || keyname.includes("logo")) {
          files[`prev${keyname}`] = page.initialValues[keyname];
          delete page.initialValues[keyname];
        }
      });
      page.initialValues.files = files;
      form.setFieldsValue({ ...page.initialValues });
      if (page.initialValues.files) setFiles(page.initialValues.files);
      setEditData(page.initialValues);
    }
    if (page && page.forms && page.forms.initRequests) {
      page.forms.initRequests.map((req) => {
        if (req.url.includes("$storeid")) {
          req.url = req.url.replace("$storeid", props._auth.user.storeid);
        }
        props.request({
          url: req.url,
          method: req.method ? req.method : "GET",
          model: req.model,
        });
      });
    }
  }, [form]);

  const print = useReactToPrint({
    content: () => printRef.current,
  });

  /* Баруун эсвэл Зүүн талд хамаарах Формуудын зурах хэсэг */
  const renderForms = (type) => {
    const { forms } = page;
    if (forms && forms[type]) {
      if (forms[type].Component) {
        var SubComponent = forms[type].Component;
        return (
          <SubComponent
            form={form}
            editData={editData}
            {...props}
            columns={forms[type].columns}
            name={forms[type].name}
            method={forms[type].method}
            url={forms[type].url}
            buttonText={forms[type].buttonText}
            isModal={forms[type].isModal}
            filterOption={forms[type].filterOption}
            initData={initData}
          />
        );
      }
      return (
        forms[type].form &&
        forms[type].form.map((item, i) => (
          <Components.FormItems
            props={props}
            item={item}
            form={form}
            key={i}
            files={files}
            setFiles={setFiles}
            setChanged={setChanged}
            changed={changed}
            setInitData={setInitData}
          />
        ))
      );
    }
  };

  const handleModal = () => setIsOpen(true);

  const closeModal = (e) => setIsOpen(false);

  const renderSubmitBtn = () => (
    <div>
      <Button
        type="primary"
        loading={loading}
        className="w-fit"
        htmlType="submit"
        style={{ float: "right" }}
      >
        Хадгалах
      </Button>
      <Button
        className="w-fit mr-2"
        style={{ float: "right" }}
        onClick={() => navigate(-1)}
      >
        Буцах
      </Button>
      {forms.isPrint && editData && Object.keys(editData).length > 0 ? (
        <Button
          className="w-fit mr-2"
          style={{ float: "right" }}
          onClick={print}
        >
          Хэвлэх
        </Button>
      ) : null}
      {page.changePassBtn ? (
        <Button
          className="w-fit mr-2"
          onClick={handleModal}
          style={{ float: "right" }}
        >
          Нууц үг сэргээх
        </Button>
      ) : null}
      {page.editBtn ? (
        <Button
          className="w-fit mr-2"
          onClick={handleModal}
          style={{ float: "right" }}
        >
          Засах
        </Button>
      ) : null}
    </div>
  );

  /* Хадгалаад амжилттай бол лист ийг дахин дуудах */
  const sendDataRefresh = () => {
    let searchValues = JSON.parse(localStorage.getItem(`search${page.url}`));
    if (!searchValues) {
      searchValues = { foodid: props._auth.foodid };
    }
    if (page.url === "/report/inventory" && props?._auth?.user?.type === 2) {
      searchValues = {
        storeid: props?._auth?.user?.storeid,
      };
    }
    props.request({
      url: page.url,
      body: searchValues,
      method: page.method,
      model: page.model,
    });
  };

  /* Форм хадгалах */
  const handleSave = (values) => {
    try {
      values = { ...values, ...files };
      if (forms.url && forms.method) {
        setLoading(true);
        if (
          forms.url === "/movement" ||
          forms.url === "/product/buy" ||
          forms.url === "/order"
        ) {
          values.amount = values.amt;
        }
        Object.keys(values).map((keyname) => {
          if (keyname.includes("dfield")) delete values[keyname];
          if (keyname.includes("ymd"))
            values[keyname] = dayjs(values[keyname]).format("YYYY-MM-DD");
          if (values[keyname] === null) values[keyname] = "";
          if (keyname === "orderid")
            values[keyname] = values[keyname] ? values[keyname] : 0;
          if (
            keyname === "hastax" ||
            keyname === "iskiosk" ||
            keyname === "isprodfooter" ||
            keyname === "isonly"
          )
            values[keyname] = values[keyname]
              ? IsEnable.Идэвхтэй
              : IsEnable.Идэвхгүй;
        });
        let url = forms.url;
        if (values.jsondata) {
          let jsData = JSON.parse(values.jsondata);
          if (jsData) {
            if (forms.url.includes("{storeid}")) {
              url = url.replace("{storeid}", editData.id);
            }
            values = [];
            jsData.map((item, i) => {
              values.push({ productid: item.id, qty: item.qty });
              // if (item.qty > 0) {
              //   values.push({ productid: item.id, qty: item.qty });
              // }
            });
          }
        }

        props
          .request({
            url: url,
            body: values,
            method: forms.method,
            isfile: forms.isFile,
          })
          .then((res) => {
            setLoading(false);
            if (res.success) {
              if (forms.nextUrl) {
                setLoading(true);
                props
                  .request({
                    url: `${forms.nextUrl}/${res.data.id}`,
                    body: values.products,
                    method: forms.method,
                    isfile: forms.nextIsFile,
                  })
                  .then((res) => {
                    setLoading(false);
                  });
              }
              if (forms.isClear) form.resetFields();
              if (forms.isMessage) owntoast(res.message, "success");
              if (forms.isRefresh && page.isList) {
                sendDataRefresh();
                navigate(-1);
              } else {
                sendDataRefresh();
              }
            } else {
              if (forms.isMessage) owntoast(res.message, "error");
            }
          });
      } else {
        Object.keys(values).map((keyname) => {
          if (keyname.includes("dfield")) delete values[keyname];
          if (keyname.includes("ymd"))
            values[keyname] = dayjs(values[keyname]).format("YYYY-MM-DD");
          if (keyname === "hastax" || keyname === "iskiosk")
            values[keyname] = values[keyname]
              ? IsEnable.Идэвхтэй
              : IsEnable.Идэвхгүй;
        });
      }
    } catch (message) {
      setLoading(false);
      if (forms.isMessage) owntoast(message, "error");
    }
  };

  const { forms } = page;
  return (
    <Spin spinning={loading}>
      {forms &&
        forms.helps &&
        forms.helps.map((item, i) => (
          <Alert key={i} {...item} showIcon className="mb-5" />
        ))}
      <Form
        initialValues={{
          isenable: 1,
        }}
        form={form}
        name="baseForm"
        labelCol={{ flex: "10rem" }}
        labelAlign="left"
        labelWrap
        wrapperCol={{ flex: 1 }}
        layout="horizontal"
        onFinish={handleSave}
      >
        <Form.Item name="id" hidden>
          <Input />
        </Form.Item>
        <div className="grid grid-cols-12 gap-x-0 md:gap-x-10 gap-y-5">
          {/* Баруун талд харагдах форм - ууд зурах */}
          <div
            className={`col-span-12 sm:col-span-12 md:col-span-12 ${
              forms && forms.full
                ? "lg:col-span-12 xl:col-span-12 2xl:col-span-12"
                : "lg:col-span-5 xl:col-span-5 2xl:col-span-5"
            }`}
          >
            {renderForms("leftForms")}
            {forms && forms.noButton
              ? null
              : forms && !forms["rightForms"]
              ? renderSubmitBtn()
              : null}
          </div>
          {/* Зүүн талд харагдах форм - ууд зурах */}
          <div className="col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-7 xl:col-span-7 2xl:col-span-7">
            {renderForms("rightForms")}
            {forms && forms["rightForms"] ? renderSubmitBtn() : null}
          </div>
          <div className="col-span-12">
            {forms && forms.BottomComponent ? (
              <forms.BottomComponent
                form={form}
                changed={changed}
                request={props.request}
                editData={editData}
              />
            ) : null}
          </div>
        </div>
      </Form>
      <Modal isOpen={isOpen} onClose={closeModal} {...props} />
      <div className="hidden">
        <SaleBill ref={printRef} data={printData} />
      </div>
    </Spin>
  );
}

export default AddOrEdit;
